import React, {
    useState,
} from 'react';
import {
    Container,
    Col, Row,
    Navbar, Nav,
} from 'react-bootstrap';
import {
    withAuthenticator,
    AmplifySignOut,
} from '@aws-amplify/ui-react'

import {
    Top,
    Everything,
} from './components/filter';
import ContentArea from './components/content';
import ProfileArea from './components/profile';
import { queryToString } from './components/utils'

import './custom.css';
import logo from './logo.jpg';


function App() {
    const [ query, updateQuery ] = useState({});
    return (
        <Container>
            <Row>
                <Col>
                    <Navbar bg="light" className="mx-5">
                        <Navbar.Brand href="/">
                            <img src={logo} className="d-inline-block align-top" alt="logo" width="30" height="30" />
                            {' '}
                            News
                        </Navbar.Brand>
                        <Navbar.Collapse>
                            <Nav
                                className="mr-auto"
                                variant="pills"
                                defaultActiveKey={query.type || 'top'}
                                onSelect={(key) => updateQuery({...query, type: key})}
                            >
                                <Nav.Item>
                                    <Nav.Link eventKey="top">
                                        Top headlines
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="everything">
                                        Everything
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <Nav>
                                <AmplifySignOut />
                            </Nav>
                        </Navbar.Collapse>
                    </Navbar>
                </Col>
            </Row>
            <Row className="border-bottom-0 mt-3 ml-5 mr-5">
                <Col lg={8} md={12} sm={12}>
                    {(query.type || "top") === "top" &&
                        <Top query={query} updateQuery={updateQuery} key={queryToString(query)} />
                    }
                    {query.type === "everything" &&
                        <Everything query={query} updateQuery={updateQuery} key={queryToString(query)} />
                    }
                    <ContentArea query={query} />
                </Col>
                <Col lg={4} md={12} sm={12}>
                    <ProfileArea updateQuery={updateQuery} />
                </Col>
            </Row>
        </Container>
    );
}

export default withAuthenticator(App)
